import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import './Footer.scss';
export default function Footer() {    
    const [info, setInfo] = useState(null);   
    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const response = await apiFetch({ path: "/ultimate-security/v1/plugin-info", method: 'GET' });
        
                // Save to localStorage
                localStorage.setItem("plusInfo", JSON.stringify(response));
        
                // Update state
                setInfo(response);
            } catch (error) {
                console.error("Error fetching info:", error);
            }
        };
        
        // Check if data is already in localStorage
        const storedInfo = localStorage.getItem("plusInfo");
        if (storedInfo) {
            setInfo(JSON.parse(storedInfo));
        } else {
            fetchInfo();
        }
    }, []);
    return (
        <div className="ultimate-security-footer p-lg">
            <div className="row justify-content-between align-items-center">
                <div className="col-12 d-flex align-items-center gap-3 col-lg-auto text-center text-lg-start">
                    <a href="https://www.programmelab.com/" target="_blank">
                        <img src={ultimate_security_ajax_obj.imageUrl+'pl-icon-sm.svg'} alt="plugin-icon"/>
                        <h6 className='mb-0'>{__("Ultimate Security", 'ultimate-security')}</h6>
                    </a>
                    <a href="https://www.programmelab.com/" target="_blank">
                        <span>{__("About", 'ultimate-security')} </span>
                        <img src={ultimate_security_ajax_obj.imageUrl+'navigate-to.svg'} alt="navigate-icon"/>
                    </a>
                    <a href="https://www.programmelab.com/" target="_blank">
                        <span>{__("Privacy", 'ultimate-security')} </span>
                        <img src={ultimate_security_ajax_obj.imageUrl+'navigate-to.svg'} alt="navigate-icon"/>
                    </a>
                    <a href="https://www.programmelab.com/" target="_blank">
                        <span>{__("Terms", 'ultimate-security')} </span>
                        <img src={ultimate_security_ajax_obj.imageUrl+'navigate-to.svg'} alt="navigate-icon"/>
                    </a>
                    <a href="https://www.programmelab.com/" target="_blank">
                        <span>{__("Version "+ultimate_security_ajax_obj.version, 'ultimate-security')} </span>
                        <img src={ultimate_security_ajax_obj.imageUrl+'navigate-to.svg'} alt="navigate-icon"/>
                    </a>
                </div>
                <div className="coll-12 col-lg-auto text-center text-lg-end">
                    <h6>{__("A ProgrammeLab Product", 'ultimate-security')}</h6>
                </div>
            </div>            
        </div>
    )
}
